import { render, staticRenderFns } from "./CalendarAsideRatesTest.vue?vue&type=template&id=88115ade&scoped=true&"
import script from "./CalendarAsideRatesTest.vue?vue&type=script&lang=js&"
export * from "./CalendarAsideRatesTest.vue?vue&type=script&lang=js&"
import style0 from "./CalendarAsideRatesTest.vue?vue&type=style&index=0&id=88115ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88115ade",
  null
  
)

export default component.exports